import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';

export const SvgGoalDimension = {
  height: 20,
  width: 20,
  viewBox: '0 0 16 16',
};

export const SvgGoal = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      />
      <g transform="scale(0.8)">
        <path
          fill="#fff"
          d="M10 1.5A8.503 8.503 0 0 0 1.5 10c0 4.692 3.808 8.5 8.5 8.5s8.5-3.808 8.5-8.5-3.808-8.5-8.5-8.5m.85 2.805 1.148-.807a6.8 6.8 0 0 1 3.723 2.838l-.332 1.14-1.147.39-3.392-2.371zm-2.847-.807 1.147.807v1.19L5.758 7.866l-1.147-.39-.332-1.14a6.9 6.9 0 0 1 3.723-2.839M5.817 14.344l-.969.085A6.75 6.75 0 0 1 3.2 10c0-.102.008-.195.017-.297l.85-.621 1.173.408 1.241 3.689zm6.307 2.108A6.8 6.8 0 0 1 10 16.8a6.8 6.8 0 0 1-2.125-.349l-.586-1.266.543-.935h4.344l.544.944zm-.195-3.902H8.07L6.923 9.133 10 6.974l3.085 2.159zm3.221 1.878-.969-.085-.671-1.164 1.24-3.689 1.182-.4.85.621c.008.094.017.187.017.289 0 1.691-.62 3.239-1.649 4.429"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
));
